import { render } from "./simulation.vue?vue&type=template&id=8adcc35c"
import script from "./simulation.vue?vue&type=script&lang=js"
export * from "./simulation.vue?vue&type=script&lang=js"

import "./simulation.vue?vue&type=style&index=0&id=8adcc35c&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__